module.exports = __webpack_public_path__ + "img/sj@2x.db6c5611.png";